import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {
  // scope = { category: 'campaign' | 'brand' | 'product' | 'all', values: [ids] (none for 'all'), description }
  async submitExport (scope) {
    const response = await axiosInstance.post('/integrations/elabel-exports/', scope, { timeout: 120000 })
    return response.data
  },

  // Newest first
  async loadExports ({ limit, offset }) {
    const response = await axiosInstance.get('/integrations/elabel-exports/', { params: { limit, offset } })
    return { count: response.data.count, results: response.data.results }
  },

  async retryExport (key) {
    const response = await axiosInstance.post(`/integrations/elabel-exports/${key}/retry/`, {})
    return response.data
  },

  // This is a one-time, unauthenticated token: navigate to it rather than
  // consuming it with an authenticated XHR. Request a fresh link every time.
  async getDownloadLink (key) {
    const response = await axiosInstance.get(`/documents/${key}/get-download-link/`)
    return response.data.link
  }
}
